import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {TargetFacadeService} from '../../../../target/target-facade.service';
import {TargetAccount} from '../../../../target/target.model';
import {map, withLatestFrom} from 'rxjs/operators';


@Component({
  selector: 'app-shared-accounts-row',
  template: `
    <div class="target-accounts-wrapper">
      <ng-container *ngFor="let target of filteredTargets$ | async">
        <app-shared-accounts-icon [target]="target">
        </app-shared-accounts-icon>
      </ng-container>
    </div>
  `,
  styleUrls: ['./shared-accounts-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedAccountsRowComponent {
  targetsSource$ = this.targetsFacade.getTargets();
  ids$: Subject<number[]> = new BehaviorSubject<number[]>([]);
  filteredTargets$: Observable<TargetAccount[]> = this.ids$.asObservable()
    .pipe(
      withLatestFrom(this.targetsSource$),
      map(([ids, targets]) => targets.filter(target => target.accounts.some(acc => ids.includes(acc.id)))),
    );

  constructor(private targetsFacade: TargetFacadeService) {
  }

  @Input() set sharedAccountsIds(value: number[]) {
    if (value) {
      this.ids$.next(value);
    }
  }

}
